import {httpsCallable} from 'firebase/functions';
import {functions} from '../../lib/firebase';

// Short-lived metadata only. No answers or student progress are stored here.
const cache=new Map(),pending=new Map();
const MAX_AGE=60000,MAX_ENTRIES=6;
let activeUser=null,generation=0;
export function selectTrackerAccount(uid) {
    if(activeUser!==uid){activeUser=uid;generation++;cache.clear();pending.clear();}
}
export function cachedTrackerCatalog(uid,paperId) {
    selectTrackerAccount(uid);
    const entry=cache.get(paperId);
    return entry && Date.now()-entry.at<MAX_AGE?entry.value:null;
}
export function clearTrackerCatalog(uid,paperId) {
    selectTrackerAccount(uid);cache.delete(paperId);
}
export function loadTrackerCatalog(uid,paperId) {
    selectTrackerAccount(uid);
    if(pending.has(paperId))return pending.get(paperId);
    const currentGeneration=generation;
    const request=httpsCallable(functions,'studyTrackerCatalog',{timeout:30000});
    const promise=(async()=>{
        const questions=[],seen=new Set();let after=null,paper=null;
        do {
            const response=(await request({paperId,after})).data;
            if(activeUser!==uid || generation!==currentGeneration)throw new Error('Your account changed. Reopen the tracker.');
            if(response?.paper?.id!==paperId || !Array.isArray(response.questions))throw new Error('Invalid tracker response.');
            paper=response.paper;questions.push(...response.questions);after=response.nextCursor || null;
            if(after && (typeof after!=='string' || seen.has(after)))throw new Error('The question list could not finish loading. Try again.');
            if(after)seen.add(after);
        } while(after);
        const value={paper,questions:[...new Map(questions.map(q=>[q.id,q])).values()]};
        if(activeUser===uid && generation===currentGeneration){cache.delete(paperId);cache.set(paperId,{at:Date.now(),value});while(cache.size>MAX_ENTRIES)cache.delete(cache.keys().next().value);}
        return value;
    })();
    pending.set(paperId,promise);
    promise.then(()=>{if(pending.get(paperId)===promise)pending.delete(paperId);},()=>{if(pending.get(paperId)===promise)pending.delete(paperId);});
    return promise;
}
